/**
 * TopTransfersUserEvents
 * Registry of events for TopTransfers components
 */
export enum TopTransfersUserEvents {
    ChangeTab = "TopTransfers - Change Tab",
    TimeframeChange = "TopTransfers - Timeframe Change",
    NetworkLinkClick = "TopTransfers - Network Link Click",
    ProtocolLinkClick = "TopTransfers - Protocol Link Click",
    AssetLinkClick = "TopTransfers - Asset Link Click",
    BlockchainExplorerLinkClick = "TopTransfers - Blockchain Explorer Link Click",
    LoginCtaOpen = "TopTransfers - Login CTA Open",
    LoginCtaClose = "TopTransfers - Login CTA Close",
    LoginCtaConfirmed = "TopTransfers - Login CTA Confirmed",
}
